export const ArrowLeftMd = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="17"
         height="18"
         viewBox="0 0 17 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <path
            d="M16 9L0.999879 9"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M8.5 16.5L0.99994 8.99994L8.5 1.49988"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   )
}
